module.exports = __webpack_public_path__ + "cc5b251dcdb21c3bc25ad961164481d2.png";